// extracted by mini-css-extract-plugin
export default {"addressSection":"HP-z","disabled":"IP-z","sectionButtons":"JP-z","logo":"KP-z"};